/** Inline splash so first JS does not wait on Tailwind/antd CSS. */
const AppLoading = () => {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      aria-busy="true"
      aria-label="Loading"
    >
      <div
        style={{
          display: 'flex',
          gap: 8,
          alignItems: 'center',
          justifyContent: 'center',
        }}
        aria-hidden="true"
      >
        <span className="kk-boot-dot" style={{ animationDelay: '0s' }} />
        <span className="kk-boot-dot" style={{ animationDelay: '0.15s' }} />
        <span className="kk-boot-dot" style={{ animationDelay: '0.3s' }} />
      </div>
      <style>{`
        .kk-boot-dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #1F6476;
          animation: kk-dot 1s ease-in-out infinite;
        }
        @keyframes kk-dot {
          0%, 80%, 100% { opacity: 0.25; transform: scale(0.85); }
          40% { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </div>
  );
};

export default AppLoading;
